import React from "react"
import { CalendarColumn } from "./calendar-column";
import { StudioManager } from "../../studio-manager";

export class Calendar extends React.Component {
  constructor () {
    super();
    this.state = { days: [] };
    this.hours = [];
  }

  componentDidMount () {
    if (StudioManager.instance.agenda && StudioManager.instance.agenda.length > 0) this.calender();
    StudioManager.instance.on('calendar-loaded', this.calender);
  }

  calender = () => {
    // Helper functions
    Array.prototype.max = function() {
      return Math.max.apply(null, this);
    };

    Array.prototype.min = function() {
      return Math.min.apply(null, this);
    };
    var hours = [];
    
    StudioManager.instance.agenda.forEach(day => {
      day.events.forEach(event => {
        if (event.hour > 0) hours.push(event.hour);
      })
    });

    this.setState({
      days: StudioManager.instance.agenda,
      min: hours.min(),
      max: hours.max()
    });
  }

  render () {
    return (
      <div className="calendar">
        <h2 className="calendar__title">Playing this week</h2>
        <img src="/images/arrow.png" className="calendar__arrow" />
        <div className="calendar__content">
          { this.state.days.map(day => <CalendarColumn day={day} key={day.dayString} min={this.state.min} max={this.state.max}/>) }
        </div>
      </div>
    )
  }
}


